<template lang='pug'>
  IMList(:title='title' :listType='listType' :dialogType="dialogType" :im='getIM()')
</template>

<script>
import IMList from "../components/IMList.vue";
import * as i18n from "../data/i18n.json";
export default {
  name: "MyRequest",
  components: {
    IMList
  },
  data() {
    return {
      i18n: i18n.default,
      title: "My IM Request",
      listType: "user",
      dialogType: "user",
      im: {
        headers: [
          {
            text: "IM Number",
            value: "imNo"
          },
          {
            text: "Subject",
            value: "imPerihal"
          },
          {
            text: "Category",
            value: "imCategory"
          },
          {
            text: "Submit Date",
            value: "imDate",
          },
          {
            text: "Business Unit",
            value: "imOrganization.name",
          },
          {
            text: "Status",
            value: "imStatus",
            align: "center"
          },
          {
            text: "Actions",
            value: "actions",
          }
        ],
        items: [],
        bisnisUnit: '',
        paymentHeaders: [
          {
            text: "IM Number",
            value: "imNo",
            width: '14%',
          },
          {
            text: "Subject",
            value: "imPerihal",
            width: '30%',
          },
          {
            text: "Category",
            value: "imCategory"
          },
          {
            text: "Submit Date",
            value: "imDate",
          },
          {
            text: "Business Unit",
            value: "imOrganization.name",
          },
          {
            text: "Status",
            value: "imStatus",
            align: "center"
          },
          {
            text: "Actions",
            value: "actions",
            width: '12%',
          }
        ],
        jumlah: 0
      }
    }
  },
  mounted() {
    // this.$store.dispatch("fetchDataRequestsRefactor");
  },
  methods: {
    getIM() {
      this.im.items = this.$store.state.dataRequests.data || [];
      this.im.jumlah = this.$store.state.dataRequests.jumlah || 0;
      if(this.im.items.length > 0){
        
        for (let i = 0; i < this.im.items.length; i++) {
          this.im.items[i].imStatusLabel = this.i18n.status[
            this.im.items[i].imStatus
          ].name;
          this.im.items[i].imTypeLabel = this.i18n.imType[
            this.im.items[i].imType
          ];
          // const localization = this.im.items[i].imValue.currency == "USD" ? "en-US" : "id-ID";
          // const formatter = new Intl.NumberFormat(localization, {
          //   style: "currency",
          //   currency: this.im.items[i].imValue.currency,
          //   minimumFractionDigits: 0
          // });
          // this.im.items[i].imNilai = formatter.format(
          //   this.im.items[i].imValue.value
          // );
          
          
          // LOGIC ANOUCHEMENT && IM PAYMEN IM CATEGORY GOES HERE
          if ( this.im.items[i].hasOwnProperty('imCategory') ) {
            for( const data of this.i18n.category ) {
              if ( data.value == this.im.items[i].imCategory ) {
                this.im.items[i].imCategory = data.text
              }
            }
          } else if (this.im.items[i].imType == 6 || this.im.items[i].imType == 7) {
            this.im.items[i].imCategory = "N/A"
          } else {
            this.im.items[i].imCategory = "General"
          }
        }
      }
      return this.im;
    },
  }
};
</script>
